var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 45,
    viewBox: "0 0 39 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 6,
    width: 39,
    height: 37,
    rx: 18.5,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2944 26.89C11.8544 26.89 11.4744 26.74 11.1544 26.44C10.8544 26.12 10.7044 25.74 10.7044 25.3C10.7044 24.86 10.8544 24.49 11.1544 24.19C11.4744 23.87 11.8544 23.71 12.2944 23.71H17.5444C17.7044 23.71 17.7844 23.62 17.7844 23.44V18.31C17.7844 17.85 17.9544 17.45 18.2944 17.11C18.6344 16.77 19.0344 16.6 19.4944 16.6C19.9544 16.6 20.3544 16.77 20.6944 17.11C21.0344 17.45 21.2044 17.85 21.2044 18.31V23.44C21.2044 23.62 21.2844 23.71 21.4444 23.71H26.6944C27.1344 23.71 27.5044 23.87 27.8044 24.19C28.1244 24.49 28.2844 24.86 28.2844 25.3C28.2844 25.74 28.1244 26.12 27.8044 26.44C27.5044 26.74 27.1344 26.89 26.6944 26.89H21.4444C21.2844 26.89 21.2044 26.98 21.2044 27.16V32.29C21.2044 32.75 21.0344 33.15 20.6944 33.49C20.3544 33.83 19.9544 34 19.4944 34C19.0344 34 18.6344 33.83 18.2944 33.49C17.9544 33.15 17.7844 32.75 17.7844 32.29V27.16C17.7844 26.98 17.7044 26.89 17.5444 26.89H12.2944Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcons);
export default __webpack_public_path__ + "static/media/plusIcons.dad96edb0502c364e845d054122fd5e9.svg";
export { ForwardRef as ReactComponent };